import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKAllocation implements EntityAware {
    @serialize
    @deserialize
    public name: string = "";

    @serialize
    @deserialize
    public value: number = 0;
}
